import { render, staticRenderFns } from "./marquee-shopzovya.vue?vue&type=template&id=5862a10c&scoped=true&"
import script from "./marquee-shopzovya.vue?vue&type=script&lang=js&"
export * from "./marquee-shopzovya.vue?vue&type=script&lang=js&"
import style0 from "./marquee-shopzovya.vue?vue&type=style&index=0&id=5862a10c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5862a10c",
  null
  
)

export default component.exports